// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { OtherSubjectRoleManagement, OtherSubjectRoleManagementSchema } from 'api/gen/OtherSubjectRoleManagement';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Username, UsernameSchema } from 'api/gen/Username';

const requiredPart = t.interface({
  isSubjectMember: t.boolean,
  roles: t.array(OtherSubjectRoleManagementSchema),
  userProfileId: t.Integer,
  username: UsernameSchema,
});

export const UserProfileSubjectRoleManagementDtoOtherSubjectRoleManagementSchema = excess(requiredPart);

export interface UserProfileSubjectRoleManagementDtoOtherSubjectRoleManagement extends t.TypeOf<typeof UserProfileSubjectRoleManagementDtoOtherSubjectRoleManagementSchema> {}
